import { graphql } from "@opensea/graphql"
import { FeaturedCollectionsCarouselFragment } from "../FeaturedCollectionsCarousel/FeaturedCollectionsCarousel.fragment"
import { FeaturedItemsCarouselFragment } from "../FeaturedItemsCarousel/FeaturedItemsCarousel.fragment"
import { FreeformContentCarouselFragment } from "../FreeformContentCarousel/FreeformContentCarousel.fragment"
import { TimelineContentBlockCarouselFragment } from "../TimelineContentBlockCarousel/TimelineContentBlockCarousel.fragment"

export const ContentBlockCarouselFragment = graphql(
  `
    fragment ContentBlockCarousel on CollectionContentBlockModule {
      title
      description
      sections {
        __typename
        ... on FeatureContentBlock {
          itemId
        }
      }
      ...CollectionOverviewFeaturedCollectionsCarousel
      ...FreeformContentCarousel
      ...TimelineContentBlockCarousel
      ...FeaturedItemsCarousel
    }
  `,
  [
    FreeformContentCarouselFragment,
    FeaturedCollectionsCarouselFragment,
    FeaturedItemsCarouselFragment,
    TimelineContentBlockCarouselFragment,
  ],
)
